export enum SuppliersViewEnum {
  DASHBOARD = 'Dashboard',
  CREATE = 'Create new supplier',
}
